import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import News from './components/News';

const news = (props,{ t }) => (
  <Container>
    <News {...props} />
  </Container>
);

news.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(news);
